import { render } from "./member-score-type.vue?vue&type=template&id=1c1a711a"
import script from "./member-score-type.vue?vue&type=script&lang=js"
export * from "./member-score-type.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__